export default {
    // farm status

    FARM_STATUS: [
        {
            label: "有効 ",
            value: "ACTIVE"
        },
        {
            label: "無効 ",
            value: "BLOCK"
        }
    ],

    USER_STATUS: [
        {
            label: "有効 ",
            value: "ACTIVE"
        },
        {
            label: "無効 ",
            value: "BLOCK"
        }
    ],

    CAMERA_ACCESS: [
        {
            label: "有効",
            value: "ENABLE"
        },
        {
            label: "無効",
            value: "DISABLE"
        }
    ],

    CAMERA_STATUS: [
        {
            label: "稼働中",
            value: "OPERATIONAL"
        },
        {
            label: "停止中",
            value: "NOT-OPERATIONAL"
        }
    ],

    USER_ROLE: [
        {
            label: "管理者",
            value: "WRITE"
        },
        {
            label: "閲覧者",
            value: "READ"
        }
    ],

    DEVICE_STATUS: [
        {
            label: "稼働中",
            value: "OPERATIONAL"
        },
        {
            label: "停止中",
            value: "NOT-OPERATIONAL"
        }
    ],

    DEVICE_TYPE: [
        {
            label: "シリンダー",
            value: "CYLINDER"
        },
        {
            label: "センサー",
            value: "SENSOR"
        }
    ],

    DEVISE_ACCESS: [
        {
            label: "有効",
            value: "ENABLE"
        },
        {
            label: "無効",
            value: "DISABLE"
        }
    ],

    INQUIRY_STATUS: [
        {
            label: "未対応",
            value: "UNCONFIRMED"
        },
        {
            label: "対応中",
            value: "CONFIRMED"
        },
        {
            label: "対応完了",
            value: "COMPLETED"
        }
    ]
};
